/** Flat UI strings: key -> sv | en. No Mongo — client only + localStorage for lang. */

const SV = {
  "common.loading": "Laddar...",
  "common.copy": "Kopiera",
  "common.copied": "Kopierat",
  "common.copyImage": "Kopiera bild",
  "common.copyImageFailed": "Kunde inte kopiera bild",
  "common.shareImage": "Dela bild",
  "common.shareDownloaded": "Bilden laddades ner",
  "common.shareImageFailed": "Kunde inte dela bild",
  "common.save": "Spara",
  "common.saved": "Sparat",
  "common.cancel": "Avbryt",
  "common.tbd": "TBD",
  "lang.sv": "SV",
  "lang.en": "EN",
  "theme.light": "Ljus",
  "theme.dark": "Mörk",
  "theme.ariaLabel": "Tema",
  "account.menu": "Konto",
  "account.menuAria": "Kontoinställningar",
  "account.settingsTitle": "Kontoinställningar",
  "account.language": "Språk",
  "account.dailyEmail": "Dagligt resultatmail",
  "account.dailyEmailHint": "Efter avslutad matchdag",
  "account.dailyEmailErr": "Kunde inte uppdatera mailinställningen.",

  "dashboard.brand": "GRUPPTIPSET",
  "dashboard.myTournaments": "Mina turneringar",
  "dashboard.yourGames": "Dina spel",
  "dashboard.heroDot": ".",
  "dashboard.join": "Gå med",
  "dashboard.newProject": "Nytt projekt",
  "dashboard.logout": "Logga ut",
  "dashboard.noProjects": "Du har inga projekt ännu. Skapa ett – eller be en vän om en kod.",
  "dashboard.participants": "deltagare",
  "dashboard.stakeNone": "ingen insats",
  "dashboard.stakeKr": "kr",
  "dashboard.createTitle": "Skapa projekt",
  "dashboard.createName": "Namn",
  "dashboard.createStake": "Insats per deltagare",
  "dashboard.currencyLabel": "Valuta",
  "dashboard.createHint": "Välj turnering nedan. Poäng kan justeras i projektets inställningar.",
  "dashboard.tournamentLabel": "Turnering",
  "dashboard.tournamentWC": "FIFA World Cup 2026",
  "dashboard.badgeWC": "VM",
  "dashboard.createBtn": "Skapa",
  "dashboard.joinTitle": "Gå med via inbjudningskod",
  "dashboard.joinBtn": "Gå med",
  "dashboard.joinInvalid": "Ogiltig kod",
  "dashboard.createOk": "Projekt skapat!",
  "dashboard.joinOk": "Du är med!",
  "dashboard.nameRequired": "Namn krävs",

  "help.nav": "Hjälp",
  "help.pageTitle": "Hjälp och regler",

  "admin.nav": "Admin",
  "admin.pageTitle": "Admin · API-översikt",
  "admin.intro":
    "Synkstatistik och kvoter visas bara här — inte för projekt-administratörer. Sätt SUPERUSER_EMAILS i backend.",
  "admin.quotaBtn": "Hämta live-kvot (The Odds API)",
  "admin.quotaHint": "Ett anrop kan förbruka credits enligt The Odds API.",
  "admin.quotaOkTitle": "Kvot (headers)",
  "admin.quotaErr": "The Odds API svarade {status}.",
  "admin.quotaErrGeneric": "Kunde inte hämta kvot.",
  "admin.loadErr": "Kunde inte ladda admin-översikt.",
  "admin.totalCreditsLogged": "Summa loggade The Odds API-credits (alla projekt)",
  "admin.apiSportsCallsToday": "FIFA HTTP-anrop denna session",
  "admin.apiSportsCallsTotal": "FIFA HTTP-anrop senaste bundle",
  "admin.apiSportsRemaining": "FIFA live-fetch max per synk",
  "admin.colProject": "Projekt",
  "admin.colTournament": "Turnering",
  "admin.colMembers": "Medl.",
  "admin.colScheduler": "Schema",
  "admin.colSyncs": "Synkar",
  "admin.colCreditsLog": "Credits (logg)",
  "admin.colLastFetch": "Senaste odds",
  "admin.yes": "Ja",
  "admin.no": "Nej",
  "admin.noProjects": "Inga projekt i databasen.",
  "admin.pickProjectForLiveOdds": "Välj projekt",

  "notFound.kicker": "Fel",
  "notFound.title": "404",
  "notFound.description": "Sidan finns inte eller adressen har ändrats.",
  "notFound.goProjects": "Mina turneringar",
  "notFound.goLogin": "Logga in",

  "login.tagline": "Bjud in vänner, tippa matcher och tävla om potten.",
  "login.tabLogin": "Logga in",
  "login.tabRegister": "Registrera",
  "login.labelName": "Namn",
  "login.labelEmail": "Email",
  "login.labelPassword": "Lösenord",
  "login.showPassword": "Visa lösenord",
  "login.hidePassword": "Dölj lösenord",
  "login.forgotPassword": "Glömt lösenord?",
  "login.submitBusy": "…",
  "login.submitLogin": "Logga in",
  "login.submitRegister": "Skapa konto",
  "login.welcome": "Välkommen!",
  "login.inviteBanner":
    "Du har blivit inbjuden till ett tipsprojekt. Logga in eller skapa konto så öppnas projektet automatiskt.",
  "forgotPassword.title": "Glömt lösenord",
  "forgotPassword.subtitle": "Ange din e-postadress så skickar vi en återställningslänk om kontot finns.",
  "forgotPassword.emailLabel": "Email",
  "forgotPassword.submit": "Skicka länk",
  "forgotPassword.submitBusy": "Skickar…",
  "forgotPassword.sentToast": "Om adressen finns registrerad har en återställningslänk skickats.",
  "forgotPassword.sentMessage": "Om adressen finns registrerad har en återställningslänk skickats till din e-post.",
  "forgotPassword.backToLogin": "Tillbaka till login",
  "resetPassword.title": "Välj nytt lösenord",
  "resetPassword.subtitle": "Fyll i ditt nya lösenord nedan.",
  "resetPassword.newPassword": "Nytt lösenord",
  "resetPassword.confirmPassword": "Bekräfta lösenord",
  "resetPassword.submit": "Spara nytt lösenord",
  "resetPassword.submitBusy": "Sparar…",
  "resetPassword.invalidLink": "Länken är ogiltig eller har gått ut.",
  "resetPassword.mismatch": "Lösenorden matchar inte.",
  "resetPassword.success": "Ditt lösenord har uppdaterats. Logga in med det nya lösenordet.",
  "resetPassword.backToLogin": "Tillbaka till login",
  "invite.joinOk": "Du är med i projektet!",
  "invite.invalid": "Ogiltig eller utgången inbjudan.",
  "invite.joinFailed": "Kunde inte gå med just nu.",
  "invite.joining": "Går med i projektet…",
  "project.copyInviteLink": "Inbjudningslänk",
  "project.toastInviteLinkCopied": "Inbjudningslänk kopierad",
  "auth.errNetwork": "Kan inte nå servern (nätverk/CORS eller fel API-adress). Kolla konsolen och Network.",
  "auth.errServer": "Serverfel ({status}). Kolla Railway-loggar eller Network-svaret.",
  "auth.errGeneric": "Något gick fel",

  "project.back": "Tillbaka",
  "project.copyCode": "Kod:",
  "project.mailToday": "Maila idag",
  "project.menu": "Turneringsmeny",
  "project.rulesMobile": "Turneringsinställningar",
  "project.mailResults": "Maila dagens resultat",
  "project.refresh": "Uppdatera",
  "project.live": "LIVE",
  "project.offline": "OFFLINE",
  "project.tabOverview": "Översikt",
  "project.tabGroup": "Gruppspel",
  "project.groupProgress": "{filled}/{total} matcher tippade",
  "project.tabStandings": "Tabeller",
  "project.tabBracket": "Slutspel",
  "project.bracketViewList": "Lista",
  "project.bracketViewTree": "Träd",
  "project.tabLeaderboards": "Topplistor",
  "project.tabExtras": "Extra",
  "project.tabSettings": "Turnering",
  "project.matchFinished": "SLUT",
  "project.matchLive": "LIVE",
  "project.resultLabel": "Resultat:",
  "project.penWinnerTitle": "Gick vidare på straffar",
  "project.liveTeamsHint": "* = laget spelar just nu",
  "project.toastInviteCopied": "Inbjudningskod kopierad",
  "project.toastMailSent": "Summering skickad till din mail!",
  "project.toastMailSentShort": "Mail skickat!",
  "project.wsUpdateTitle": "Liveuppdatering",
  "project.wsUpdateBody": "Resultat synkat",
  "project.saveFailed": "Sparning misslyckades",
  "project.oddsCaption": "Odds",
  "project.oddsBook": "Bolag",
  "project.oddsAvgCsCaption": "Snitt",
  "project.harryBoyTitle": "Harry Boy",
  "project.harryBoyHint": "Fyller öppna matcher utifrån måloddsen under varje rad.",
  "project.harryBoyTight": "Målsnålt",
  "project.harryBoyTightTitle": "Oftast få mål — med lite variation mellan matcherna.",
  "project.harryBoyRich": "Målrikt",
  "project.harryBoyRichTitle": "Oftast många mål — med lite variation mellan matcherna.",
  "project.harryBoySafe": "Säkert",
  "project.harryBoySafeTitle": "Oftast favorit enligt oddsen — med lite variation mellan matcherna.",
  "project.harryBoyMix": "Mix",
  "project.harryBoyMixTitle": "Slumpar läge per match, med lite variation inom varje läge.",
  "project.harryBoyProgress": "Sparar {done} av {total}",
  "project.harryBoyPreparing": "Vänta …",
  "project.harryBoyNoOdds": "Synka odds först.",
  "project.harryBoyNoCandidates": "Här fanns inget att fylla — odds saknas eller matcherna är låsta.",
  "project.harryBoyGroupLocked": "Gruppspelet är låst (första gruppspelsmatchen har börjat).",
  "project.groupPhaseLockedHint": "Gruppspelet har börjat — dessa tips kan inte längre ändras.",
  "project.clearAllLocked": "Inget gick att rensa — alla matchtips du har är i en låst fas.",
  "project.harryBoyToast": "{n} matcher ifyllda.",
  "project.clearAll": "Rensa",
  "project.clearAllTitle": "Rensa alla matchtips",
  "project.clearAllConfirm": "Är du säker? Detta rensar alla dina matchtips i Gruppspel.",
  "project.clearedAllToast": "Alla matchtips rensade.",

  "flat.title": "Tabeller",
  "flat.live": "Live",
  "flat.tipped": "Tippat",
  "flat.colDate": "Datum",
  "flat.colTime": "Tid",
  "flat.colMatch": "Match",
  "flat.colTips": "Tips",
  "flat.colResult": "Resultat",
  "flat.colRound": "Runda",
  "flat.colTv": "Stream",
  "flat.groupPrefix": "Grupp",
  "flat.bestThirdTitle": "Bästa treor",
  "flat.teamCol": "LAG",
  "flat.colGP": "GP",
  "flat.colGPFull": "Spelade matcher",
  "flat.vs": "vs",
  "flat.playingNow": "Spelar just nu",
  "flat.searchPlaceholder": "Sök land (min. 2 tecken)",
  "flat.searchNoMatches": "Inga matcher med det laget.",
  "round.po": "Playoff",
  "round.r32": "Sextondelsfinal",
  "round.r16": "Åttondelsfinal",
  "round.qf": "Kvartsfinal",
  "round.sf": "Semifinal",
  "round.tpp": "Bronsmatch",
  "round.final": "Final",
  "round.finalBanner": "FINAL",
  "round.bronzeHeading": "Brons",

  "extras.title": "Extra",
  "extras.finalist1": "Finalist 1",
  "extras.finalist2": "Finalist 2",
  "extras.winner": "Vinnare",
  "extras.teamPlaceholder": "Lag",
  "extras.topscorer": "Skyttekung",
  "extras.topscorerPh": "Efternamn och lag för matchning mot skytteligan",
  "extras.topscorerPts": "poäng per mål om din spelare delar ledningen i skytteligan.",
  "extras.topscorerPtsAllScorers": "poäng för varje mål din spelare gör i turneringen.",
  "extras.topscorerPickPlayer": "Välj målskytt",
  "extras.topscorerClear": "Inget tips",
  "extras.topscorerOlHint": "Välj målskytt i listan.",
  "extras.topscorerFallbackHint":
    "Lag används bara för att koppla efternamn till rätt spelare i API-listan — inte som eget ”landstips”.",
  "extras.topscorerLastname": "Efternamn",
  "extras.topscorerLastnamePh": "t.ex. Kane",
  "extras.topscorerTeamLabelWC": "Landslag",
  "extras.topscorerTeamPlaceholder": "Välj lag",
  "extras.topscorerTeamHeadline": "Oftast valda / topplag",
  "extras.topscorerTeamRest": "Övriga (A–Ö)",
  "extras.topscorerAutoHint": "Poäng räknas automatiskt när skytteligan uppdateras.",

  "standings.predictPlacement": "Tippa placering",
  "standings.pickTeam": "Välj lag",
  "standings.place1": "1:a",
  "standings.place2": "2:a",
  "standings.place3": "3:a",
  "standings.groupsProgress": "grupper helt klara",
  "standings.title": "Tabeller & grupplaceringar",
  "standings.progressSlots": "{filled}/{total} grupp-platser ifyllda (1:a, 2:a, 3:a)",
  "standings.groupsDoneLine": "{done}/{total} grupper helt klara",
  "standings.saved": "Grupp {g} sparad",
  "standings.err": "Fel",
  "standings.fillFromMatchTips": "Fyll från gruppspeltips",
  "standings.fillFromMatchTipsTitle": "Fyller bara tomma platser (1:a, 2:a, 3:a) utifrån din tippade tabell.",
  "standings.fillFromMatchTipsToast": "{n} platser ifyllda.",
  "standings.fillFromMatchTipsNone": "Inget att fylla — tipsa fler matcher eller alla platser är redan ifyllda.",
  "standings.clearPlacements": "Rensa tabelltips",
  "standings.clearPlacementsTitle": "Rensa alla 1:a, 2:a och 3:a så du kan fylla på nytt från matchtips.",
  "standings.clearPlacementsConfirm": "Rensa alla tabellplaceringar (1:a, 2:a, 3:a)?",
  "standings.clearPlacementsToast": "Tabelltips rensade.",
  "standings.clearPlacementsNone": "Inget att rensa.",
  "standings.groupMatches": "Matcher",

  "lb.title": "Topplistor",
  "lb.subtitle": "Välj hur du vill jämföra spelarna",
  "lb.nav.matrixOverview": "Översikt",
  "lb.nav.matrixOverviewHint": "Allas tips: matcher, grupper, slutspel, extra",
  "lb.nav.pointsBoard": "Poängliga",
  "lb.nav.pointsBoardHint": "Totalställning per gren",
  "lb.nav.chart": "Diagram",
  "lb.nav.chartHint": "Totalpoäng per gren",
  "lb.nav.matches": "Matchspel",
  "lb.nav.matchesHint": "Poäng på matcher",
  "lb.nav.groups": "Grupplaceringar",
  "lb.nav.groupsHint": "1:a–3:a i gruppen",
  "lb.nav.finals": "Slutspel",
  "lb.nav.finalsHint": "Final, vinnare",
  "lb.nav.topscorer": "Skyttekung",
  "lb.nav.topscorerHint": "Skyttekungsbonus",
  "lb.nav.combo": "Mästarkollen",
  "lb.nav.comboHint": "Grupp + slutspel",

  "lb.chart.title": "Poäng efter delmoment",
  "lb.chart.filterLabel": "Visa",
  "lb.chart.filterAll": "Allt",
  "lb.chart2.title": "Poäng efter typ av träff",
  "lb.chart2.seg1x2": "1x2",
  "lb.chart2.segExact": "Resultat",
  "lb.chart2.segGroup": "Grupplacering",
  "lb.chart2.segGoals": "Mål",
  "lb.chart2.segOther": "Övrigt",

  "lb.pickMatrix.sectionGroupMatches": "Gruppspelsmatcher",
  "lb.pickMatrix.sectionGroupPicks": "Grupptips",
  "lb.pickMatrix.sectionKo": "Slutspel",
  "lb.pickMatrix.sectionExtras": "Extra",
  "lb.pickMatrix.colMatch": "Match",
  "lb.pickMatrix.colGroup": "Grupp",
  "lb.pickMatrix.colPick": "Tips",
  "lb.pickMatrix.extraFinalistN": "Finalist {n}",
  "lb.pickMatrix.extraWinner": "Vinnare",
  "lb.pickMatrix.extraTopscorer": "Skyttekung",
  "lb.pickMatrix.copyMatchdayPicks": "Kopiera matchdagens tips (bild)",
  "lb.pickMatrix.matchdayTitle": "Matchdag · {date}",
  "lb.pickMatrix.colMatchdayPlayer": "Tippare",
  "lb.emptyTotal": "Inga matcher avgjorda än — totalpoäng visas så fort det finns resultat",
  "lb.emptyCategory": "Inga poäng i den här kategorin än",
  "lb.colRank": "#",
  "lb.colPlayer": "Spelare",
  "lb.colMatches": "Matcher",
  "lb.colGroupMatches": "Gruppspel",
  "lb.colKoMatches": "Slutspel",
  "lb.colGroups": "Grupper",
  "lb.colFinals": "Final",
  "lb.colTop": "Mål",
  "lb.colCombo": "G+S",
  "lb.colTotal": "Totalt",
  "lb.comboFootnote": "Mästarkollen = poäng från grupplaceringar plus slutspel/final (sorteras på summan i kolumnen G+S).",
  "lb.scorersSubtitle": "{pts} poäng per mål om din spelare delar ledningen i skytteligan.",
  "lb.scorersSubtitleAllPicks": "{pts} poäng för varje mål din spelare gör i turneringen.",
  "lb.scorersEmpty": "Inga målskyttar i listan ännu.",
  "lb.scorerColRank": "#",
  "lb.scorerColPlayer": "Spelare",
  "lb.scorerColTeam": "Lag",
  "lb.scorerColGoals": "Mål",
  "lb.scorerColTips": "Tippat av",
  "lb.topscorerPointsTitle": "Poäng från skyttekungstipset",

  "settings.pageTitle": "Turneringsinställningar",
  "settings.sectionTheme": "Utseende",
  "settings.rulesTitle": "Poängregler",
  "settings.sectionMembers": "Deltagare",
  "settings.sectionEconomy": "Insats & vinstpott",
  "settings.economyPot": "Vinstpott",
  "settings.economyFormula": "insats × antal deltagare",
  "settings.economyStakeLabel": "Insats per deltagare",
  "settings.economyCurrencyLabel": "Valuta",
  "settings.economyPrizeTitle": "Vinstfördelning",
  "settings.economyPlace": "#",
  "settings.economyMode": "Typ",
  "settings.economyModePercent": "% av potten",
  "settings.economyModeCurrency": "Belopp",
  "settings.economyModeStake": "Insats (åter)",
  "settings.economyModePercentShort": "%",
  "settings.economyModeCurrencyShort": "Belopp",
  "settings.economyModeStakeShort": "Insats",
  "settings.economyValue": "Värde",
  "settings.economyComputed": "Beräknat",
  "settings.economyAllocated": "Utbetalt i tabellen",
  "settings.economyRemainder": "Kvar i potten",
  "settings.economyOver": "Över potten",
  "settings.economyAddRow": "Lägg till placering",
  "settings.economyRemove": "Ta bort",
  "settings.economySave": "Spara insats & vinst",
  "settings.economySaved": "Sparat",
  "settings.economyReadOnly": "Endast organiserare eller admin kan ändra.",
  "settings.swishTitle": "Swish-betalning",
  "settings.swishHint": "Privat Swish-nummer för insatsen. Deltagare skannar QR-koden eller öppnar Swish med förifylld insats och meddelande.",
  "settings.swishPhoneLabel": "Swish-mobil (organisatör)",
  "settings.swishPhonePlaceholder": "070-123 45 67",
  "settings.swishInvalid": "Ogiltigt svenskt mobilnummer för Swish.",
  "settings.swishOpen": "Öppna Swish",
  "settings.swishScanHint": "Skanna med Swish-appen",
  "settings.paymentHint": "Betalningsstatus nedan syns bara för dig som organiserare eller admin.",
  "settings.paidLabel": "Betald",
  "settings.sectionRules": "Poängregler",
  "settings.sectionLive": "Live-resultat",
  "settings.sectionInvite": "Inbjudan",
  "settings.inviteCodeHint": "Dela koden så kan andra gå med i turneringen.",
  "settings.inviteLinkLabel": "Inbjudningslänk",
  "settings.inviteLinkHint": "Dela länken. Mottagaren loggar in eller registrerar sig och hamnar sedan i projektet.",
  "settings.sectionDelete": "Radera projekt",
  "settings.badgeCreator": "Skapare",
  "settings.badgeOrganizer": "Organisatör",
  "settings.badgeAdmin": "Admin",
  "settings.organizerSwitch": "Organisatör",
  "settings.adminSwitch": "Admin",
  "settings.organizerLastHint": "Minst en organisatör måste finnas kvar. Sista organisatören kan inte lämna eller avaktiveras.",
  "settings.removeMember": "Ta bort deltagare",
  "settings.leaveProject": "Lämna projekt",
  "settings.confirmLeave": "Lämna projektet? Dina tips raderas.",
  "settings.confirmRemove": "Ta bort {name} från projektet? Deras tips raderas.",
  "settings.leftOk": "Du har lämnat projektet",
  "settings.removedOk": "Deltagare borttagen",
  "settings.memberErr": "Kunde inte spara",
  "settings.liveReadOnlyHint": "Endast organisatör kan byta datakälla.",
  "settings.rulesHintOwner": "Justera poängvärdena.",
  "settings.rulesHintMember": "Endast organisatör kan ändra poängvärden.",
  "settings.saveRules": "Spara regler",
  "settings.rulesSaved": "Regler uppdaterade",
  "settings.liveTitle": "Live-resultat (automatisk synk)",
  "settings.liveHint": "Liveresultat hämtas från FIFA api v3. Servern pollar oftare (ca varje minut) när matcher spelas live eller just ska starta, annars varannan minut. Arenor och kickoffs kommer från FIFA.",
  "settings.liveSource": "Datakälla",
  "settings.liveOL": "FIFA api v3 (officiell källa)",
  "settings.liveFD": "football-data.org (kräver API-nyckel på servern)",
  "settings.saveLive": "Spara live-källa",
  "settings.liveSaved": "Live-källa sparad",
  "settings.sectionOdds": "Odds-hämtning",
  "settings.oddsHint":
    "1X2-referensodds (Svenska Spel, Unibet, Kalshi) hämtas via The Odds API och sparas i projektet (endast VM). Om API:et avvisar kombinationen försöker servern igen med bara Svenska Spel och Unibet. Med ODDS_API_IO_KEY sparas vid samma synk de fem troligaste slutresultaten (snitt Svenska Spel / Unibet SE från Odds-API.io; övriga utfall finns i API men sparas inte). Schemalagd odds-synk körs bara för VM-projekt. Inget hämtas automatiskt förrän du aktiverar schemaläggaren eller trycker på synk-knappen.",
  "settings.oddsLastLabel": "Senast hämtad:",
  "settings.oddsNever": "aldrig",
  "settings.oddsSyncBtn": "Hämta odds nu",
  "settings.oddsSyncBusy": "Hämtar…",
  "settings.oddsSyncOk": "Odds uppdaterade.",
  "settings.oddsSyncEmpty": "Inga nya odds hämtades. Befintliga odds lämnades orörda.",
  "settings.oddsSyncErr": "Odds kunde inte hämtas.",
  "settings.oddsScheduler": "Schemalagd synk (högst var 12:e timme)",
  "settings.oddsSchedulerHint":
    "När den är på försöker servern hämta om det gått minst 12 timmar sedan senaste lyckade hämtning (gäller även efter manuell synk).",
  "settings.oddsSchedulerOwnerOnly": "Endast skaparen kan slå på/av schemalagd synk.",
  "settings.oddsSyncStatsHint":
    "Historik sparas per projekt från och med denna app-version; äldre synkar syns inte här.",
  "settings.oddsSyncStatCount": "Antal loggade synkar",
  "settings.oddsSyncStatCreditsAvg": "Snitt The Odds API-credits per synk",
  "settings.oddsSyncStatCreditsTotal": "Summa The Odds API-credits (logg)",
  "settings.oddsSyncStatIoAvg": "Snitt HTTP-anrop Odds-API.io per synk",
  "settings.oddsSyncStatNone": "Ingen synkhistorik ännu.",
  "settings.activeSource": "Aktiv källa:",
  "settings.sourceOL": "FIFA",
  "settings.sourceFD": "football-data.org",
  "settings.inviteCode": "Inbjudningskod",
  "settings.rule.group_1x2": "Gruppspel 1X2",
  "settings.rule.group_exact": "Gruppspel exakt resultat",
  "settings.rule.ko_1x2": "Slutspel 1X2",
  "settings.rule.ko_exact": "Slutspel exakt resultat",
  "settings.rule.group_correct_first": "Rätt grupp-1:a",
  "settings.rule.group_correct_second": "Rätt grupp-2:a",
  "settings.rule.group_correct_third": "Rätt grupp-3:a",
  "settings.rule.group_misplaced": "Felplacerad grupplacering",
  "settings.rule.finalist": "Rätt finallag (per lag)",
  "settings.rule.winner": "Rätt vinnare",
  "settings.rule.topscorer_leader_bonus": "Skyttekung — poäng per mål",
  "settings.rule.topscorer_award_mode": "Skyttekung — poäng till",
  "settings.maxPointsTitle": "Maxpoäng (med nuvarande regler)",
  "settings.maxPointsMatchesGroup": "Matcher (gruppspel)",
  "settings.maxPointsMatchesKo": "Matcher (slutspel)",
  "settings.maxPointsGroups": "Grupper",
  "settings.maxPointsFinals": "Final",
  "settings.maxPointsTopscorer": "Skyttekung",
  "settings.maxPointsTopscorerUnknown": "—",
  "settings.maxPointsTotal": "Totalt",
  "settings.topscorerAwardMode.leaderOnly": "Endast skyttekung",
  "settings.topscorerAwardMode.allPicks": "Alla skyttar",
  "settings.deleteTitle": "Radera projekt",
  "settings.deleteHint": "Alla tips, resultat och deltagare i detta projekt tas bort permanent. Detta går inte att ångra.",
  "settings.deleteOpen": "Radera projekt…",
  "settings.deleteDialogTitle": "Radera permanent?",
  "settings.deleteDialogBody": "Skriv projektets namn exakt som det står:",
  "settings.deletePh": "Projektnamn",
  "settings.deleteConfirm": "Radera för alltid",
  "settings.deleteBusy": "Raderar…",
  "settings.deleteOk": "Projektet är raderat",
  "settings.deleteErr": "Kunde inte radera",
};

const EN = {
  "common.loading": "Loading...",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.copyImage": "Copy image",
  "common.copyImageFailed": "Couldn't copy image",
  "common.shareImage": "Share image",
  "common.shareDownloaded": "Image downloaded",
  "common.shareImageFailed": "Couldn't share image",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.cancel": "Cancel",
  "common.tbd": "TBD",
  "lang.sv": "SV",
  "lang.en": "EN",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.ariaLabel": "Theme",
  "account.menu": "Account",
  "account.menuAria": "Account settings",
  "account.settingsTitle": "Account settings",
  "account.language": "Language",
  "account.dailyEmail": "Daily results email",
  "account.dailyEmailHint": "After each finished matchday",
  "account.dailyEmailErr": "Could not update email preference.",

  "dashboard.brand": "GRUPPTIPSET",
  "dashboard.myTournaments": "My tournaments",
  "dashboard.yourGames": "Your games",
  "dashboard.heroDot": ".",
  "dashboard.join": "Join",
  "dashboard.newProject": "New project",
  "dashboard.logout": "Log out",
  "dashboard.noProjects": "You have no projects yet. Create one—or ask a friend for a code.",
  "dashboard.participants": "players",
  "dashboard.stakeNone": "no stake",
  "dashboard.stakeKr": "SEK",
  "dashboard.createTitle": "Create project",
  "dashboard.createName": "Name",
  "dashboard.createStake": "Stake per player",
  "dashboard.currencyLabel": "Currency",
  "dashboard.createHint": "Pick a tournament below. Points can be adjusted in project settings.",
  "dashboard.tournamentLabel": "Tournament",
  "dashboard.tournamentWC": "FIFA World Cup 2026",
  "dashboard.badgeWC": "WC",
  "dashboard.createBtn": "Create",
  "dashboard.joinTitle": "Join with invite code",
  "dashboard.joinBtn": "Join",
  "dashboard.joinInvalid": "Invalid code",
  "dashboard.createOk": "Project created!",
  "dashboard.joinOk": "You’re in!",
  "dashboard.nameRequired": "Name is required",

  "help.nav": "Help",
  "help.pageTitle": "Help and rules",

  "admin.nav": "Admin",
  "admin.pageTitle": "Admin · API overview",
  "admin.intro":
    "Sync stats and quotas are only shown here — not for project admins. Set SUPERUSER_EMAILS in the backend.",
  "admin.quotaBtn": "Fetch live quota (The Odds API)",
  "admin.quotaHint": "One request may consume credits per The Odds API pricing.",
  "admin.quotaOkTitle": "Quota (headers)",
  "admin.quotaErr": "The Odds API returned {status}.",
  "admin.quotaErrGeneric": "Could not fetch quota.",
  "admin.loadErr": "Could not load admin overview.",
  "admin.totalCreditsLogged": "Sum of logged The Odds API credits (all projects)",
  "admin.apiSportsCallsToday": "FIFA HTTP calls this session",
  "admin.apiSportsCallsTotal": "FIFA HTTP calls last bundle",
  "admin.apiSportsRemaining": "FIFA live-fetch max per sync",
  "admin.colProject": "Project",
  "admin.colTournament": "Tournament",
  "admin.colMembers": "Members",
  "admin.colScheduler": "Scheduler",
  "admin.colSyncs": "Syncs",
  "admin.colCreditsLog": "Credits (log)",
  "admin.colLastFetch": "Last odds fetch",
  "admin.yes": "Yes",
  "admin.no": "No",
  "admin.noProjects": "No projects in the database.",
  "admin.pickProjectForLiveOdds": "Select project",

  "notFound.kicker": "Error",
  "notFound.title": "404",
  "notFound.description": "This page doesn’t exist or the address has changed.",
  "notFound.goProjects": "My tournaments",
  "notFound.goLogin": "Log in",

  "login.tagline": "Invite friends, predict matches, and compete for the pot.",
  "login.tabLogin": "Sign in",
  "login.tabRegister": "Register",
  "login.labelName": "Name",
  "login.labelEmail": "Email",
  "login.labelPassword": "Password",
  "login.showPassword": "Show password",
  "login.hidePassword": "Hide password",
  "login.forgotPassword": "Forgot password?",
  "login.submitBusy": "…",
  "login.submitLogin": "Sign in",
  "login.submitRegister": "Create account",
  "login.welcome": "Welcome!",
  "login.inviteBanner":
    "You’ve been invited to a tipping pool. Sign in or create an account and the project will open automatically.",
  "forgotPassword.title": "Forgot password",
  "forgotPassword.subtitle": "Enter your email and we’ll send a reset link if the account exists.",
  "forgotPassword.emailLabel": "Email",
  "forgotPassword.submit": "Send link",
  "forgotPassword.submitBusy": "Sending…",
  "forgotPassword.sentToast": "If the address exists, a reset link has been sent.",
  "forgotPassword.sentMessage": "If the address exists, a reset link has been sent to your email.",
  "forgotPassword.backToLogin": "Back to login",
  "resetPassword.title": "Choose a new password",
  "resetPassword.subtitle": "Enter your new password below.",
  "resetPassword.newPassword": "New password",
  "resetPassword.confirmPassword": "Confirm password",
  "resetPassword.submit": "Save new password",
  "resetPassword.submitBusy": "Saving…",
  "resetPassword.invalidLink": "This reset link is invalid or has expired.",
  "resetPassword.mismatch": "Passwords do not match.",
  "resetPassword.success": "Your password has been updated. Sign in with your new password.",
  "resetPassword.backToLogin": "Back to login",
  "invite.joinOk": "You’ve joined the project!",
  "invite.invalid": "Invalid or expired invite.",
  "invite.joinFailed": "Could not join right now.",
  "invite.joining": "Joining the project…",
  "project.copyInviteLink": "Invite link",
  "project.toastInviteLinkCopied": "Invite link copied",
  "auth.errNetwork": "Cannot reach the server (network/CORS or wrong API URL). Check the console and Network tab.",
  "auth.errServer": "Server error ({status}). Check Railway logs or the Network response.",
  "auth.errGeneric": "Something went wrong",

  "project.back": "Back",
  "project.copyCode": "Code:",
  "project.mailToday": "Email today",
  "project.menu": "Tournament menu",
  "project.rulesMobile": "Tournament settings",
  "project.mailResults": "Email today’s results",
  "project.refresh": "Refresh",
  "project.live": "LIVE",
  "project.offline": "OFFLINE",
  "project.tabOverview": "Overview",
  "project.tabGroup": "Group stage",
  "project.groupProgress": "{filled}/{total} matches predicted",
  "project.tabStandings": "Tables",
  "project.tabBracket": "Knockout",
  "project.bracketViewList": "List",
  "project.bracketViewTree": "Tree",
  "project.tabLeaderboards": "Leaderboards",
  "project.tabExtras": "Extras",
  "project.tabSettings": "Tournament",
  "project.matchFinished": "FT",
  "project.matchLive": "LIVE",
  "project.resultLabel": "Score:",
  "project.penWinnerTitle": "Advanced on penalties",
  "project.liveTeamsHint": "* = team is playing now",
  "project.toastInviteCopied": "Invite code copied",
  "project.toastMailSent": "Summary sent to your email!",
  "project.toastMailSentShort": "Email sent!",
  "project.wsUpdateTitle": "Live update",
  "project.wsUpdateBody": "Scores synced",
  "project.saveFailed": "Save failed",
  "project.oddsCaption": "Odds",
  "project.oddsBook": "Book",
  "project.oddsAvgCsCaption": "Avg",
  "project.harryBoyTitle": "Harry Boy",
  "project.harryBoyHint": "Fills open picks from the score odds under each match.",
  "project.harryBoyTight": "Low-scoring",
  "project.harryBoyTightTitle": "Usually low-scoring — with some variation between matches.",
  "project.harryBoyRich": "High-scoring",
  "project.harryBoyRichTitle": "Usually high-scoring — with some variation between matches.",
  "project.harryBoySafe": "Safe",
  "project.harryBoySafeTitle": "Usually the odds favourite — with some variation between matches.",
  "project.harryBoyMix": "Mix",
  "project.harryBoyMixTitle": "Random mode per match, with some variation within each mode.",
  "project.harryBoyProgress": "Saving {done} of {total}",
  "project.harryBoyPreparing": "Hang on…",
  "project.harryBoyNoOdds": "Sync odds first.",
  "project.harryBoyNoCandidates": "Nothing to fill here — no odds or matches are locked.",
  "project.harryBoyGroupLocked": "Group stage is locked (the first group match has started).",
  "project.groupPhaseLockedHint": "The group stage has started — these picks can no longer be changed.",
  "project.clearAllLocked": "Nothing was cleared — all your match picks are in a locked phase.",
  "project.harryBoyToast": "{n} matches filled.",
  "project.clearAll": "Clear",
  "project.clearAllTitle": "Clear all match picks",
  "project.clearAllConfirm": "Are you sure? This clears all your Group Stage match picks.",
  "project.clearedAllToast": "All match picks cleared.",

  "flat.title": "Tables",
  "flat.live": "Live",
  "flat.tipped": "Predicted",
  "flat.colDate": "Date",
  "flat.colTime": "Time",
  "flat.colMatch": "Match",
  "flat.colTips": "Picks",
  "flat.colResult": "Score",
  "flat.colRound": "Round",
  "flat.colTv": "Stream",
  "flat.groupPrefix": "Group",
  "flat.bestThirdTitle": "Best third-placed",
  "flat.teamCol": "TEAM",
  "flat.colGP": "GP",
  "flat.colGPFull": "Games played",
  "flat.vs": "vs",
  "flat.playingNow": "Playing now",
  "flat.searchPlaceholder": "Search country (min. 2 characters)",
  "flat.searchNoMatches": "No matches for that team.",
  "round.po": "Playoffs",
  "round.r32": "Round of 32",
  "round.r16": "Round of 16",
  "round.qf": "Quarter-finals",
  "round.sf": "Semi-finals",
  "round.tpp": "Third place play-off",
  "round.final": "Final",
  "round.finalBanner": "FINAL",
  "round.bronzeHeading": "Third place",

  "extras.title": "Extras",
  "extras.finalist1": "Finalist 1",
  "extras.finalist2": "Finalist 2",
  "extras.winner": "Winner",
  "extras.teamPlaceholder": "Team",
  "extras.topscorer": "Top scorer",
  "extras.topscorerPh": "Last name and team for matching the scorers chart",
  "extras.topscorerPts": "points per goal if your player shares the top-scorer lead.",
  "extras.topscorerPtsAllScorers": "points per goal your player scores in the tournament.",
  "extras.topscorerPickPlayer": "Pick a scorer",
  "extras.topscorerClear": "No pick",
  "extras.topscorerOlHint": "Pick your top scorer from the list.",
  "extras.topscorerFallbackHint":
    "Team is only to disambiguate your last name against the API scorer list — not as a standalone country pick.",
  "extras.topscorerLastname": "Last name",
  "extras.topscorerLastnamePh": "e.g. Kane",
  "extras.topscorerTeamLabelWC": "National team",
  "extras.topscorerTeamPlaceholder": "Pick team",
  "extras.topscorerTeamHeadline": "Popular / headline teams",
  "extras.topscorerTeamRest": "All others (A–Z)",
  "extras.topscorerAutoHint": "Points update automatically when the scorers chart updates.",

  "standings.predictPlacement": "Predict placement",
  "standings.pickTeam": "Pick team",
  "standings.place1": "1st",
  "standings.place2": "2nd",
  "standings.place3": "3rd",
  "standings.groupsProgress": "groups fully complete",
  "standings.title": "Tables & group picks",
  "standings.progressSlots": "{filled}/{total} group slots filled (1st, 2nd, 3rd)",
  "standings.groupsDoneLine": "{done}/{total} groups fully complete",
  "standings.saved": "Group {g} saved",
  "standings.err": "Error",
  "standings.fillFromMatchTips": "Fill from group-stage picks",
  "standings.fillFromMatchTipsTitle": "Only fills empty slots (1st, 2nd, 3rd) from your tipped table.",
  "standings.fillFromMatchTipsToast": "{n} slots filled.",
  "standings.fillFromMatchTipsNone": "Nothing to fill — tip more matches or all slots are already filled.",
  "standings.clearPlacements": "Clear table picks",
  "standings.clearPlacementsTitle": "Clear all 1st, 2nd and 3rd picks so you can fill again from match tips.",
  "standings.clearPlacementsConfirm": "Clear all table placements (1st, 2nd, 3rd)?",
  "standings.clearPlacementsToast": "Table picks cleared.",
  "standings.clearPlacementsNone": "Nothing to clear.",
  "standings.groupMatches": "Matches",

  "lb.title": "Leaderboards",
  "lb.subtitle": "Choose how to compare players",
  "lb.nav.matrixOverview": "All picks",
  "lb.nav.matrixOverviewHint": "Everyone's tips in one grid",
  "lb.nav.pointsBoard": "Points",
  "lb.nav.pointsBoardHint": "Standings by category",
  "lb.nav.chart": "Charts",
  "lb.nav.chartHint": "Total points as bars by category",
  "lb.nav.matches": "Matches",
  "lb.nav.matchesHint": "Points from match picks",
  "lb.nav.groups": "Group picks",
  "lb.nav.groupsHint": "1st–3rd in group",
  "lb.nav.finals": "Knockout",
  "lb.nav.finalsHint": "Final, winner",
  "lb.nav.topscorer": "Top scorer",
  "lb.nav.topscorerHint": "Top scorer bonus",
  "lb.nav.combo": "Championship check",
  "lb.nav.comboHint": "Group + knockout",

  "lb.chart.title": "Points by segment",
  "lb.chart.filterLabel": "Show",
  "lb.chart.filterAll": "All",
  "lb.chart2.title": "Points by hit type",
  "lb.chart2.seg1x2": "1X2",
  "lb.chart2.segExact": "Score",
  "lb.chart2.segGroup": "Group placement",
  "lb.chart2.segGoals": "Goals",
  "lb.chart2.segOther": "Other",

  "lb.pickMatrix.sectionGroupMatches": "Group stage matches",
  "lb.pickMatrix.sectionGroupPicks": "Group order picks",
  "lb.pickMatrix.sectionKo": "Knockout",
  "lb.pickMatrix.sectionExtras": "Extras",
  "lb.pickMatrix.colMatch": "Match",
  "lb.pickMatrix.colGroup": "Group",
  "lb.pickMatrix.colPick": "Pick",
  "lb.pickMatrix.extraFinalistN": "Finalist {n}",
  "lb.pickMatrix.extraWinner": "Winner",
  "lb.pickMatrix.extraTopscorer": "Top scorer",
  "lb.pickMatrix.copyMatchdayPicks": "Copy matchday picks (image)",
  "lb.pickMatrix.matchdayTitle": "Matchday · {date}",
  "lb.pickMatrix.colMatchdayPlayer": "Player",
  "lb.emptyTotal": "No finished matches yet — total points appear once there are results",
  "lb.emptyCategory": "No points in this category yet",
  "lb.colRank": "#",
  "lb.colPlayer": "Player",
  "lb.colMatches": "Matches",
  "lb.colGroupMatches": "Group",
  "lb.colKoMatches": "Knockout",
  "lb.colGroups": "Groups",
  "lb.colFinals": "Finals",
  "lb.colTop": "Goals",
  "lb.colCombo": "G+KO",
  "lb.colTotal": "Total",
  "lb.comboFootnote": "Championship check = group placement points plus knockout/final (sorted by the G+KO column sum).",
  "lb.scorersSubtitle": "{pts} points per goal if your player shares the top-scorer lead.",
  "lb.scorersSubtitleAllPicks": "{pts} points per goal your player scores.",
  "lb.scorersEmpty": "No goal scorers in the list yet.",
  "lb.scorerColRank": "#",
  "lb.scorerColPlayer": "Player",
  "lb.scorerColTeam": "Team",
  "lb.scorerColGoals": "Goals",
  "lb.scorerColTips": "Picked by",
  "lb.topscorerPointsTitle": "Points from top-scorer picks",

  "settings.pageTitle": "Tournament settings",
  "settings.sectionTheme": "Appearance",
  "settings.rulesTitle": "Scoring rules",
  "settings.sectionMembers": "Participants",
  "settings.sectionEconomy": "Stake & prize pool",
  "settings.economyPot": "Prize pool",
  "settings.economyFormula": "stake × participants",
  "settings.economyStakeLabel": "Stake per player",
  "settings.economyCurrencyLabel": "Currency",
  "settings.economyPrizeTitle": "Prize split",
  "settings.economyPlace": "#",
  "settings.economyMode": "Type",
  "settings.economyModePercent": "% of pool",
  "settings.economyModeCurrency": "Fixed amount",
  "settings.economyModeStake": "Stake (entry back)",
  "settings.economyModePercentShort": "%",
  "settings.economyModeCurrencyShort": "Amount",
  "settings.economyModeStakeShort": "Stake",
  "settings.economyValue": "Value",
  "settings.economyComputed": "Calculated",
  "settings.economyAllocated": "Allocated in table",
  "settings.economyRemainder": "Remaining in pool",
  "settings.economyOver": "Over pool",
  "settings.economyAddRow": "Add place row",
  "settings.economyRemove": "Remove",
  "settings.economySave": "Save stake & prizes",
  "settings.economySaved": "Saved",
  "settings.economyReadOnly": "Only organisers or admins can edit.",
  "settings.swishTitle": "Swish payment",
  "settings.swishHint": "Private Swish number for the stake. Participants scan the QR code or open Swish with the stake and message prefilled.",
  "settings.swishPhoneLabel": "Swish mobile (organiser)",
  "settings.swishPhonePlaceholder": "070-123 45 67",
  "settings.swishInvalid": "Invalid Swedish mobile number for Swish.",
  "settings.swishOpen": "Open Swish",
  "settings.swishScanHint": "Scan with the Swish app",
  "settings.paymentHint": "Payment toggles below are visible only to the organiser and admins.",
  "settings.paidLabel": "Paid",
  "settings.sectionRules": "Scoring rules",
  "settings.sectionLive": "Live results",
  "settings.sectionInvite": "Invite",
  "settings.inviteCodeHint": "Share the code so others can join the tournament.",
  "settings.inviteLinkLabel": "Invite link",
  "settings.inviteLinkHint": "Share the link. Recipients sign in or register and land in the project.",
  "settings.sectionDelete": "Delete project",
  "settings.badgeCreator": "Creator",
  "settings.badgeOrganizer": "Organiser",
  "settings.badgeAdmin": "Admin",
  "settings.organizerSwitch": "Organiser",
  "settings.adminSwitch": "Admin",
  "settings.organizerLastHint": "At least one organiser must remain. The last organiser cannot leave or be demoted.",
  "settings.removeMember": "Remove participant",
  "settings.leaveProject": "Leave project",
  "settings.confirmLeave": "Leave this project? Your picks will be deleted.",
  "settings.confirmRemove": "Remove {name} from the project? Their picks will be deleted.",
  "settings.leftOk": "You left the project",
  "settings.removedOk": "Participant removed",
  "settings.memberErr": "Could not save",
  "settings.liveReadOnlyHint": "Only an organiser can change the data source.",
  "settings.rulesHintOwner": "Adjust point values.",
  "settings.rulesHintMember": "Only an organiser can change point values.",
  "settings.saveRules": "Save rules",
  "settings.rulesSaved": "Rules updated",
  "settings.liveTitle": "Live results (auto sync)",
  "settings.liveHint": "Live scores come from FIFA api v3. The server polls more often (about every minute) while matches are live or about to kick off, otherwise every two minutes. Venues and kickoffs come from FIFA.",
  "settings.liveSource": "Data source",
  "settings.liveOL": "FIFA api v3 (official source)",
  "settings.liveFD": "football-data.org (requires API key on server)",
  "settings.saveLive": "Save live source",
  "settings.liveSaved": "Live source saved",
  "settings.sectionOdds": "Odds fetching",
  "settings.oddsHint":
    "1X2 reference odds (Svenska Spel, Unibet, Kalshi) come from The Odds API and are stored on the project (World Cup only). If the API rejects the bookmaker set, the server retries with Svenska Spel and Unibet only. With ODDS_API_IO_KEY, the same sync also stores the five most likely correct scores (Svenska Spel / Unibet SE average from Odds-API.io; other outcomes exist in the API but are not stored). Scheduled odds sync runs only for World Cup projects. Nothing is fetched automatically until you enable the scheduler or tap sync.",
  "settings.oddsLastLabel": "Last fetched:",
  "settings.oddsNever": "never",
  "settings.oddsSyncBtn": "Fetch odds now",
  "settings.oddsSyncBusy": "Fetching…",
  "settings.oddsSyncOk": "Odds updated.",
  "settings.oddsSyncEmpty": "No new odds were fetched. Existing odds were left unchanged.",
  "settings.oddsSyncErr": "Could not fetch odds.",
  "settings.oddsScheduler": "Scheduled sync (at most every 12 hours)",
  "settings.oddsSchedulerHint":
    "When on, the server fetches only if at least 12 hours have passed since the last successful fetch (including after a manual sync).",
  "settings.oddsSchedulerOwnerOnly": "Only the creator can turn scheduled sync on or off.",
  "settings.oddsSyncStatsHint":
    "Per-project history is stored starting with this app version; older syncs are not listed.",
  "settings.oddsSyncStatCount": "Logged syncs",
  "settings.oddsSyncStatCreditsAvg": "Avg The Odds API credits per sync",
  "settings.oddsSyncStatCreditsTotal": "Total The Odds API credits (log)",
  "settings.oddsSyncStatIoAvg": "Avg Odds-API.io HTTP requests per sync",
  "settings.oddsSyncStatNone": "No sync history yet.",
  "settings.activeSource": "Active source:",
  "settings.sourceOL": "FIFA",
  "settings.sourceFD": "football-data.org",
  "settings.inviteCode": "Invite code",
  "settings.rule.group_1x2": "Group stage 1X2",
  "settings.rule.group_exact": "Group stage exact score",
  "settings.rule.ko_1x2": "Knockout 1X2",
  "settings.rule.ko_exact": "Knockout exact score",
  "settings.rule.group_correct_first": "Correct group 1st",
  "settings.rule.group_correct_second": "Correct group 2nd",
  "settings.rule.group_correct_third": "Correct group 3rd",
  "settings.rule.group_misplaced": "Misplaced group pick",
  "settings.rule.finalist": "Correct finalist (per team)",
  "settings.rule.winner": "Correct winner",
  "settings.rule.topscorer_leader_bonus": "Top scorer — points per goal",
  "settings.rule.topscorer_award_mode": "Top scorer — award bonus to",
  "settings.maxPointsTitle": "Max points (with current rules)",
  "settings.maxPointsMatchesGroup": "Matches (group stage)",
  "settings.maxPointsMatchesKo": "Matches (knockout)",
  "settings.maxPointsGroups": "Groups",
  "settings.maxPointsFinals": "Final",
  "settings.maxPointsTopscorer": "Top scorer",
  "settings.maxPointsTopscorerUnknown": "—",
  "settings.maxPointsTotal": "Total",
  "settings.topscorerAwardMode.leaderOnly": "Only top scorer",
  "settings.topscorerAwardMode.allPicks": "Everyone with a pick",
  "settings.deleteTitle": "Delete project",
  "settings.deleteHint": "All picks, results and members for this project are removed permanently. This cannot be undone.",
  "settings.deleteOpen": "Delete project…",
  "settings.deleteDialogTitle": "Delete permanently?",
  "settings.deleteDialogBody": "Type the project name exactly as shown:",
  "settings.deletePh": "Project name",
  "settings.deleteConfirm": "Delete forever",
  "settings.deleteBusy": "Deleting…",
  "settings.deleteOk": "Project deleted",
  "settings.deleteErr": "Could not delete",
};

const UI = { sv: SV, en: EN };

export function translate(lang, key, vars) {
  const L = UI[lang] || UI.sv;
  let s = L[key] ?? UI.sv[key] ?? key;
  if (vars && typeof s === "string") {
    Object.entries(vars).forEach(([k, v]) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
    });
  }
  return s;
}
